import './Main-nav-sheet'
import './Booking-sheet'
import './Booking-table-sheet'
import './Hotellist-sheet'
// import './Lang-sheet'
import './Product-sheet'
import './Voucher-sheet'
import './Gift-certificate-sheet'
import './Cart-sheet'
import './align-logo-text'

( function (){
    const productImg=document.querySelector('.side-sheet__footer-img-src');
    const productTitle=document.querySelector('.side-sheet__footer-text');
    var productHover=document.getElementsByClassName('product-nav-details');
    for (var i=0;i<productHover.length;i++){
        productHover[i].addEventListener('mouseover',function(){
            var dataHoverImage=this.getAttribute("data-hover-img");
            var dataHoverName=this.getAttribute("data-hover-title");
            productImg.src=dataHoverImage;
            productTitle.innerHTML=dataHoverName;
        })
    }
    
    //for the disabled button when no destination is selected
    setInterval( () => {
        const destChecked = document.querySelector('[name="destination"].sub-nav__input:checked');
        // const catChecked = document.querySelector('[name="category"].sub-nav__input:checked');
        const disable = document.querySelector('#btn-cert-categ');
        if(destChecked ){
            disable.classList.remove("no-pointer-events");
            disable.classList.remove("bg-gray");
        }
        else{
            disable.classList.add("no-pointer-events");
            disable.classList.add("bg-gray");            
        }
    },20)
    
})()
